import styled from "styled-components";
import { Card } from "waapi/waap-ui/components/Card/Card.js";
import { flex } from "waapi/waap-ui/components/Flex/Flex.style.js";

export const StyledRedCard = styled(Card)`
    ${flex};
    border-color: ${({ theme }) => theme.colors.error[80]};
    background-color: ${({ theme }) => theme.colors.pink[5]};
`;
